// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationBeforeLogin-root-Ugcp1 {
	margin: 0;
}

.NavigationBeforeLogin-link-wRMxB {
	display: inline-block;
	padding: 3px 8px;
	text-decoration: none;
	font-size: 1.125em;
}

.NavigationBeforeLogin-link-wRMxB,
.NavigationBeforeLogin-link-wRMxB:active,
.NavigationBeforeLogin-link-wRMxB:visited {
	color: rgba(255, 255, 255, 0.6);
}

.NavigationBeforeLogin-link-wRMxB:hover {
	color: rgba(255, 255, 255, 1);
}

.NavigationBeforeLogin-highlight-WOs3z {
	margin-right: 8px;
	margin-left: 8px;
	border-radius: 3px;
	background: rgba(0, 0, 0, 0.15);
	color: #fff;
}

.NavigationBeforeLogin-highlight-WOs3z:hover {
	background: rgba(0, 0, 0, 0.3);
}

.NavigationBeforeLogin-spacer-RdmQ_ {
	color: rgba(255, 255, 255, 0.3);
}

.NavigationBeforeLogin-centerLink-eUZ0j {
	display: inline-block;
	font-size: 18px;
	color: #ffffff;
	margin-right: 50px;
	font-weight: 600;
}

.NavigationBeforeLogin-centerLink-eUZ0j:last-child {
	margin: 0;
}

.NavigationBeforeLogin-centerLink-eUZ0j a,
.NavigationBeforeLogin-centerLink-eUZ0j a:hover,
.NavigationBeforeLogin-centerLink-eUZ0j a:focus {
	color: #ffffff;
	text-decoration: none;
}

.NavigationBeforeLogin-dot-sZTPi {
	position: relative;
}

.NavigationBeforeLogin-dot-sZTPi::after {
	content: '';
	width: 6px;
	height: 6px;
	background: var(--common-primary-white-foreground);
	border-radius: 50%;
	position: absolute;
	top: 48%;
	right: -26px;
}

.NavigationBeforeLogin-dot-sZTPi::before {
	content: '';
	width: 57px;
	height: 1.5px;
	background: var(--common-primary-white-foreground);
	position: absolute;
	bottom: -3px;
	right: 0;
	left: 0;
	margin: 0 auto;
}

.NavigationBeforeLogin-innerLink-s6BFp a {
	color: var(--primary-foreground) !important;
	font-size: 16px;
	text-decoration: none !important;
}

.NavigationBeforeLogin-floatLeft-Smtbs {
	float: left;
}

.NavigationBeforeLogin-disPlayInline-Pmwqd {
	display: inline-block;
}

.NavigationBeforeLogin-innerLink-s6BFp {
	width: 120px;
}

.NavigationBeforeLogin-themeIcon-zr21n {
	margin: 0 8px;
}

.NavigationBeforeLogin-themeIconSec-aMoU4 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	font-size: 16px;
	gap: 4px;
}

.NavigationBeforeLogin-themeIconAlignment-vmXxK {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.NavigationBeforeLogin-languageFlex-scWvw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
}

.NavigationBeforeLogin-textColor-u3yZM {
	color: var(--primary-foreground);
}

.NavigationBeforeLogin-selectedThemeColor-fT8Zq {
	color: var(--secondary-bg);
}

.NavigationBeforeLogin-loginBtn-wyi5D {
	background: transparent;
	font-weight: bold;
	border-radius: 25px;
	font-size: 18px !important;
	/* padding: 5px 10px; */
	margin-left: 10px;
}

.NavigationBeforeLogin-divider-qjFnQ {
	width: 2px;
	height: 30px;
	background: #fff;
	display: inline-block;
	margin: 0 16px;
}

.nav li a:hover {
	background: transparent !important;
}

.NavigationBeforeLogin-mh10-qtJ5q {
	margin: 0 10px 0 10px;
}

@media screen and (min-width: 768px) {
	.NavigationBeforeLogin-paddingDropDown-WLJ0u {
		padding-right: 0px !important;
		margin-left: 5px;
	}
}

@media screen and (max-width:1199px) {
	.NavigationBeforeLogin-newMenu-y2I0_ {
		height: 100vh;
		background: #fff !important;
	}

	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 20px;
		border-top: 1px solid var(--border-secondary-color);
	}

	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 60px;
		border-top: 1px solid var(--primary-border);
		background-color: var(--background-primary);
	}

	.NavigationBeforeLogin-mbTop-v7Egh a {
		padding-top: 13px !important;
	}
}

@media screen and (max-width: 1199px) {
	.NavigationBeforeLogin-tabViewHidden-FbVCd {
		display: none !important;
	}
}

@media screen and (max-width:1199px) and (min-width:768px) {
	.NavigationBeforeLogin-newMenu-y2I0_ {
		left: 0;
	}

	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 60px;
	}

	.NavigationBeforeLogin-mbTop-v7Egh a {
		padding-top: 8px !important;
	}
}

@media screen and (max-width:767px) {
	.NavigationBeforeLogin-newMenuDesign-XkbNw {
		margin-top: 40px;
	}

	.NavigationBeforeLogin-mbTop-v7Egh a {
		padding-top: 8px !important;
	}

}

.NavigationBeforeLogin-appStoreSection-NBRdj {
	position: fixed;
	bottom: 24px;
	right: 50%;
	-webkit-transform: translateX(calc(50% + 220px));
	    -ms-transform: translateX(calc(50% + 220px));
	        transform: translateX(calc(50% + 220px));
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-align: end;
	    -ms-flex-align: end;
	        align-items: flex-end;
	z-index: 1050;
}

.NavigationBeforeLogin-appStoreText-WEACX {
	font-size: 13px;
	color: #fff;
	margin: 0 0 10px 0;
	font-weight: 500;
	line-height: 1.4;
	text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.NavigationBeforeLogin-appStoreIcons-ui1ED {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.NavigationBeforeLogin-storeIcon-t4BGt {
	height: 35px;
	width: auto;
	cursor: pointer;
	-webkit-transition: opacity 0.2s ease;
	transition: opacity 0.2s ease;
	-webkit-filter: brightness(0) invert(1);
	        filter: brightness(0) invert(1);
}

.NavigationBeforeLogin-storeIcon-t4BGt:hover {
	opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationBeforeLogin/NavigationBeforeLogin.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;;;CAGC,+BAA+B;AAChC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,+BAA+B;CAC/B,WAAW;AACZ;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,SAAS;AACV;;AAEA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kDAAkD;CAClD,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,kDAAkD;CAClD,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,OAAO;CACP,cAAc;AACf;;AAGA;CACC,2CAA2C;CAC3C,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,0BAA0B;CAC1B,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;AACf;;AAGA;CACC,kCAAkC;AACnC;;AAGA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,6BAA6B;EAC7B,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;EAChB,mDAAmD;CACpD;;CAEA;EACC,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;CAC5C;;CAEA;EACC,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,OAAO;CACR;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;AAED;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,UAAU;CACV,gDAAwC;KAAxC,4CAAwC;SAAxC,wCAAwC;CACxC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,sBAAqB;KAArB,mBAAqB;SAArB,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,sCAAsC;AACvC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,qCAA6B;CAA7B,6BAA6B;CAC7B,uCAA+B;SAA/B,+BAA+B;AAChC;;AAEA;CACC,YAAY;AACb","sourcesContent":[".root {\n\tmargin: 0;\n}\n\n.link {\n\tdisplay: inline-block;\n\tpadding: 3px 8px;\n\ttext-decoration: none;\n\tfont-size: 1.125em;\n}\n\n.link,\n.link:active,\n.link:visited {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n.link:hover {\n\tcolor: rgba(255, 255, 255, 1);\n}\n\n.highlight {\n\tmargin-right: 8px;\n\tmargin-left: 8px;\n\tborder-radius: 3px;\n\tbackground: rgba(0, 0, 0, 0.15);\n\tcolor: #fff;\n}\n\n.highlight:hover {\n\tbackground: rgba(0, 0, 0, 0.3);\n}\n\n.spacer {\n\tcolor: rgba(255, 255, 255, 0.3);\n}\n\n.centerLink {\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tcolor: #ffffff;\n\tmargin-right: 50px;\n\tfont-weight: 600;\n}\n\n.centerLink:last-child {\n\tmargin: 0;\n}\n\n.centerLink a,\n.centerLink a:hover,\n.centerLink a:focus {\n\tcolor: #ffffff;\n\ttext-decoration: none;\n}\n\n.dot {\n\tposition: relative;\n}\n\n.dot::after {\n\tcontent: '';\n\twidth: 6px;\n\theight: 6px;\n\tbackground: var(--common-primary-white-foreground);\n\tborder-radius: 50%;\n\tposition: absolute;\n\ttop: 48%;\n\tright: -26px;\n}\n\n.dot::before {\n\tcontent: '';\n\twidth: 57px;\n\theight: 1.5px;\n\tbackground: var(--common-primary-white-foreground);\n\tposition: absolute;\n\tbottom: -3px;\n\tright: 0;\n\tleft: 0;\n\tmargin: 0 auto;\n}\n\n\n.innerLink a {\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 16px;\n\ttext-decoration: none !important;\n}\n\n.floatLeft {\n\tfloat: left;\n}\n\n.disPlayInline {\n\tdisplay: inline-block;\n}\n\n.innerLink {\n\twidth: 120px;\n}\n\n.themeIcon {\n\tmargin: 0 8px;\n}\n\n.themeIconSec {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 16px;\n\tgap: 4px;\n}\n\n.themeIconAlignment {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.languageFlex {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolumn-gap: 10px;\n}\n\n.textColor {\n\tcolor: var(--primary-foreground);\n}\n\n.selectedThemeColor {\n\tcolor: var(--secondary-bg);\n}\n\n.loginBtn {\n\tbackground: transparent;\n\tfont-weight: bold;\n\tborder-radius: 25px;\n\tfont-size: 18px !important;\n\t/* padding: 5px 10px; */\n\tmargin-left: 10px;\n}\n\n.divider {\n\twidth: 2px;\n\theight: 30px;\n\tbackground: #fff;\n\tdisplay: inline-block;\n\tmargin: 0 16px;\n}\n\n\n:global(.nav) li a:hover {\n\tbackground: transparent !important;\n}\n\n\n.mh10 {\n\tmargin: 0 10px 0 10px;\n}\n\n@media screen and (min-width: 768px) {\n\t.paddingDropDown {\n\t\tpadding-right: 0px !important;\n\t\tmargin-left: 5px;\n\t}\n}\n\n@media screen and (max-width:1199px) {\n\t.newMenu {\n\t\theight: 100vh;\n\t\tbackground: #fff !important;\n\t}\n\n\t.newMenuDesign {\n\t\tmargin-top: 20px;\n\t\tborder-top: 1px solid var(--border-secondary-color);\n\t}\n\n\t.newMenuDesign {\n\t\tmargin-top: 60px;\n\t\tborder-top: 1px solid var(--primary-border);\n\t\tbackground-color: var(--background-primary);\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 13px !important;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.tabViewHidden {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width:1199px) and (min-width:768px) {\n\t.newMenu {\n\t\tleft: 0;\n\t}\n\n\t.newMenuDesign {\n\t\tmargin-top: 60px;\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 8px !important;\n\t}\n}\n\n@media screen and (max-width:767px) {\n\t.newMenuDesign {\n\t\tmargin-top: 40px;\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 8px !important;\n\t}\n\n}\n\n.appStoreSection {\n\tposition: fixed;\n\tbottom: 24px;\n\tright: 50%;\n\ttransform: translateX(calc(50% + 220px));\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tz-index: 1050;\n}\n\n.appStoreText {\n\tfont-size: 13px;\n\tcolor: #fff;\n\tmargin: 0 0 10px 0;\n\tfont-weight: 500;\n\tline-height: 1.4;\n\ttext-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n\n.appStoreIcons {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.storeIcon {\n\theight: 35px;\n\twidth: auto;\n\tcursor: pointer;\n\ttransition: opacity 0.2s ease;\n\tfilter: brightness(0) invert(1);\n}\n\n.storeIcon:hover {\n\topacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NavigationBeforeLogin-root-Ugcp1`,
	"link": `NavigationBeforeLogin-link-wRMxB`,
	"highlight": `NavigationBeforeLogin-highlight-WOs3z`,
	"spacer": `NavigationBeforeLogin-spacer-RdmQ_`,
	"centerLink": `NavigationBeforeLogin-centerLink-eUZ0j`,
	"dot": `NavigationBeforeLogin-dot-sZTPi`,
	"innerLink": `NavigationBeforeLogin-innerLink-s6BFp`,
	"floatLeft": `NavigationBeforeLogin-floatLeft-Smtbs`,
	"disPlayInline": `NavigationBeforeLogin-disPlayInline-Pmwqd`,
	"themeIcon": `NavigationBeforeLogin-themeIcon-zr21n`,
	"themeIconSec": `NavigationBeforeLogin-themeIconSec-aMoU4`,
	"themeIconAlignment": `NavigationBeforeLogin-themeIconAlignment-vmXxK`,
	"languageFlex": `NavigationBeforeLogin-languageFlex-scWvw`,
	"textColor": `NavigationBeforeLogin-textColor-u3yZM`,
	"selectedThemeColor": `NavigationBeforeLogin-selectedThemeColor-fT8Zq`,
	"loginBtn": `NavigationBeforeLogin-loginBtn-wyi5D`,
	"divider": `NavigationBeforeLogin-divider-qjFnQ`,
	"mh10": `NavigationBeforeLogin-mh10-qtJ5q`,
	"paddingDropDown": `NavigationBeforeLogin-paddingDropDown-WLJ0u`,
	"newMenu": `NavigationBeforeLogin-newMenu-y2I0_`,
	"newMenuDesign": `NavigationBeforeLogin-newMenuDesign-XkbNw`,
	"mbTop": `NavigationBeforeLogin-mbTop-v7Egh`,
	"tabViewHidden": `NavigationBeforeLogin-tabViewHidden-FbVCd`,
	"appStoreSection": `NavigationBeforeLogin-appStoreSection-NBRdj`,
	"appStoreText": `NavigationBeforeLogin-appStoreText-WEACX`,
	"appStoreIcons": `NavigationBeforeLogin-appStoreIcons-ui1ED`,
	"storeIcon": `NavigationBeforeLogin-storeIcon-t4BGt`
};
module.exports = ___CSS_LOADER_EXPORT___;
